// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.partnerInformationModal[data-v-ab61b720] .modal-body {
      max-height: 80vh;
      min-height: 10vh;
      overflow-y: auto;
}
#message-body[data-v-ab61b720] {
      white-space: pre-wrap;
}
[data-v-ab61b720] .modal-footer > div {
      width: 100%;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
